// features/Vault/vault.constants.tsx

import { type ICategory } from 'types/interfaces/ITypes'

export const makeAllCategory = (): ICategory => ({
  id: null,
  name: 'All',
  posts: 0,
  premium: 0,
  stories: 0,
  messages: 0,
  selected: true,
  public: 0,
  suggestions: false,
  created_at: new Date().toISOString(),
})

export type MediaType = 'all_media' | 'photos' | 'videos'

export const buildFeedFilter = () => ({
  first_section: [
    {
      value: 'group_by_post',
      isToggle: true,
      name: (
        <span>
          Group by Post <span style={{ color: '#b0b3b6', fontWeight: 300 }}>|</span> Message
        </span>
      ),
      subText: 'Ungrouped will show all media'

    },
    { value: 'mass_messages', name: 'Mass Messages', isToggle: true },
  ],
  second_section: [
    { value: 'price', name: 'Price Set', isToggle: true },
    {
      value: 'show_duplicates',
      name: 'Group Duplicates',
      isToggle: true,
      subText: 'Only Show Most Recently Shared'
    },
    {
      value: 'all_time_stats',
      name: 'All Time Stats',
      isToggle: true,
      // subText: ''
    },
    { value: 'unreleased_only', name: 'Unreleased Only', isToggle: true },
  ],
  third_section: [
    { value: 'all_media', name: 'All Media' },
    { value: 'photos', name: 'Photos' },
    { value: 'videos', name: 'Videos' },
  ],
})

export const feedSort = {
  first_section: [
    { value: 'most_recent', name: 'Latest Published' },
    { value: 'conversion_rate', name: 'Conversion Rate' },
    { value: 'views', name: 'Views' },
    { value: 'impressions', name: 'Impressions' },
    { value: 'highest_tips', name: 'Tip Revenue' },
    { value: 'purchases', name: 'Purchase Count' },
    { value: 'most_liked', name: 'Most Liked' },
    { value: 'most_comment', name: 'Most Commented' },
  ],
  second_section: [
    { value: 'asc', name: 'Ascending' },
    { value: 'desc', name: 'Descending' },
  ],
}

export const messagesSort = {
  first_section: [
    { value: 'most_recent', name: 'Most Recent' },
    { value: 'conversion_rate', name: 'Conversion Rate' },
    { value: 'views', name: 'Views' },
    { value: 'impressions', name: 'Impressions' },
    { value: 'purchases', name: 'Purchases' },
  ],
  second_section: [
    { value: 'asc', name: 'Ascending' },
    { value: 'desc', name: 'Descending' },
  ],
}
